import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

const SectionLoader = ({ height = "100px" }) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        minHeight: height,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(255,255,255,0.8)",
        backdropFilter: "blur(4px)",
        zIndex: 10,
        borderRadius: 2,
      }}
    >
      <CircularProgress color="primary" size={50} />
    </Box>
  );
};

export default SectionLoader;